// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b9072587","455":"89e91a03","488":"91e8f0ff","977":"d9058cc5"}[chunkId] + ".chunk.js";
};